import { Routes, Route, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
// Duomo
import DuomoBlogs from "../component/myDuomo/blogs";
import AddBlogs from "../component/myDuomo/addBlog";
import EditBlog from "../component/myDuomo/editBlog";
// G&G
import GNGAddBlogs from "../component/gng/addBlog";
import GNGEditBlog from "../component/gng/editBlog";
import GNGBlogs from "../component/gng/blogs";
// login
import Login from "../component/login/login";
// Layout
import Layout from "../shared/layout";

const AllRoutes = () => {
  const [loggedIn, setLoggedIn] = useState(false);
  const navigate = useNavigate();

  // useEffect for loggedIn user to check
  useEffect(() => {
    let key = localStorage.getItem("login");

    if (key !== null && key === "true") {
      setLoggedIn(true);
    } else {
      navigate("/login");
      setLoggedIn(false);
    }
    // eslint-disable-next-line
  }, [localStorage.getItem("login")]);

  return (
    <>
      {/* login page */}
      {!loggedIn ? (
        <Routes>
          <Route path="/login" element={<Login />} />
        </Routes>
      ) : (
        <Layout>
          <Routes>
            <Route path="/" element={<DuomoBlogs />} />
            <Route path="/add-duomo-blog" element={<AddBlogs />} />
            <Route path="/edit-duomo-blog/:id" element={<EditBlog />} />
            {/*GNG Blog */}
            <Route path="/gng-blogs" element={<GNGBlogs />} />
            <Route path="/add-gng-blog" element={<GNGAddBlogs />} />
            <Route path="/edit-gng-blog/:id" element={<GNGEditBlog />} />
          </Routes>
        </Layout>
      )}
    </>
  );
};
export default AllRoutes;
